/**
 * Privacy notice surfaced wherever the student types content the
 * (yet-to-ship) backend would persist or send to a model — currently the
 * Study Assistant page. The copy is the canonical version called out in
 * S1-012's acceptance criteria so a single grep finds it across the app.
 */

export const PRIVACY_BANNER_TEXT =
  'Your messages are de-identified before processing. We never store or share your real name or contact details with the AI.';

export interface PrivacyBannerProps {
  /** Optional override; keep the default unless the route explicitly opts out. */
  message?: string;
}

export function PrivacyBanner({ message = PRIVACY_BANNER_TEXT }: PrivacyBannerProps) {
  return (
    <aside
      className="privacy-banner"
      role="note"
      aria-label="Privacy notice"
      data-testid="privacy-banner"
    >
      <span aria-hidden="true" className="privacy-banner__icon">
        ℹ︎
      </span>
      <p>{message}</p>
    </aside>
  );
}
